<template>
    <div class="np-group np-group-row pt-3 pb-3">
        <button class="np-btn np-mr-2" 
            :class="this.activeTab == 'summary' ? 'np-btn-secondary active' : 'np-outline'" 
            @click="switchTo('summary')">
            <svg class="icon"><use href="@/assets/images/icons/sertificate.svg#icon"></use></svg>
            {{ $t("UI.dashboard.summary") }}
        </button>
        <button class="np-btn np-mr-2" 
            :class="this.activeTab == 'calendar' ? 'np-btn-secondary active' : 'np-outline'" >
            <svg class="icon"><use href="@/assets/images/icons/calendar.svg#icon"></use></svg>
            {{ $t("UI.dashboard.calendar") }}
        </button>
        <button class="np-btn" 
            :class="this.activeTab == 'projectsAndSpaces' ? 'np-btn-secondary active' : 'np-outline'" 
            @click="switchTo('projectAndSpaces')">
            <svg class="icon"><use href="@/assets/images/icons/folder-open.svg#icon"></use></svg>
            {{ $t("UI.dashboard.projectAndSpaces") }}
        </button>
    </div>
</template>

<script>

import Config from '../../../config'

export default {
    components: {
    },
    props: {
        activeTab: {
            type: String,
            default: "summary",
            required: true
        }
    },    
    data() {
        return {
            Config
        }
    },
    methods: {
        switchTo(target) {
            this.$emit("callSwitchScreen", target)
        }
    }

}
</script>

<style>
</style>